import { useState, useEffect } from "react";
import * as bootstrap from 'bootstrap';
import '../assets/styles/explorer.css'
import { AlertMessageBox } from "./AlertMessage";

export const AddStorageModal = ({editBackend,getAllBackends,request,setRequest,handleCloseEdit,testConnectionStatus, setTestConnectionStatus}) => {
    const [backendTypes, setBackendTypes] = useState([]);
    const [showAlertBox, setShowAlertBox] = useState(false);
    const [alertMessage, setAlertMessage] = useState({
        Errortype: "Error",
        title: "",
        message: "",
    });
    const [testConnectionMessage, setTestConnectionMessage] = useState('');
    const get_backend_types = () => {
        fetch('/api/v1/backends/types', {
            method: "GET",
            headers: {
                "Content-Type": "application",
            }
        }).then(async (response) => {

            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.json()
        })
            .then(data => {
                setBackendTypes(new Set(data));
                console.log(new Set(data));
            })
            .catch(error => console.log(error));
    }
    const openAlertPopup = (errorType, title, message) => {
        setAlertMessage({
            Errortype: errorType,
            title: title,
            message: message,
        });
        setShowAlertBox(true);
        setTimeout(function () {
            setShowAlertBox(false);
        }, 2000);
    };

    const testConnection = () => {
        if (request?.backend_name != '' && request?.type != '' && request?.authKey != '' && request?.authSecret != '') {
        fetch('/api/v1/backends/test', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request)
        }).then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.json()
        })
            .then(data => {
                console.log(data);
                const { status, detail } = data;
                setTestConnectionStatus(status);
                setTestConnectionMessage(detail);
            })
            .catch(error => {
                console.error(error)
                setTestConnectionStatus(error.status || 'error');
                setTestConnectionMessage( error.detail || 'An error occured while testing connection');
            });
        }else{
            openAlertPopup("Error", "Invalid Data", "Missing required fields!!!");
        }
    }

    const add_new_storage = (event) => {
        event.preventDefault();
        let requestURL=request.id ? `/api/v1/backends/update/${request.id}`: '/api/v1/backends/create'
        let type=request.id ? 'PUT': 'POST'
        // let requestURL=request.id ? `/api/v1/backends/update/${request.id}`: '/api/v1/backends/create'
        fetch(requestURL, {
            method: type,
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(request)
        }).then(async (response) => {
            if (!response.ok) {
                const error = await response.json();
                throw error;
            }
            return response.json()
        })
            .then(data => {
                openAlertPopup(
                  "Success",
                  "Storage created successfully!!",
                  "New storage created successfully!!!"
                );
                getAllBackends();
            })
            .catch(error => {
                console.error(error)
            });
    }
    const callItem = (item) => {
        const connectionLostToast = new bootstrap.Toast(document.querySelector('#toastID'), {
            autohide: true
          });
          connectionLostToast.show();
    }
    useEffect(() => {
        get_backend_types();
    }, [])
    const inputOnChangeHandler=(e)=>{
        setRequest({ ...request,[e.target.name]:e.target.value})
    }

    return (
        <>        
        <div className="modal fade add-storage-modal-container" id="addStorageModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="addStorageModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content border-0 rounded-4">
                    <div className="modal-header border-0">
                        <h1 className="modal-title fs-5" id="addStorageModalLabel">Add Storage</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>handleCloseEdit()}></button>
                    </div>
                    <form onSubmit={(e)=>add_new_storage(e)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="backendName" className="form-label">Backend name<span className="mandatory-fields">*</span></label>
                                    <input type="text" className="form-control" id="backendName" name="backend_name"
                                        value={request.backend_name}
                                        onChange={inputOnChangeHandler} />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="backendDescription" className="form-label">Backend description</label>
                                    <input type="text" className="form-control" id="backendDescription"
                                        value={request.description}
                                        name="description"
                                        onChange={inputOnChangeHandler} />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="backendDescription" className="form-label">Backend Type<span className="mandatory-fields">*</span></label>
                                    <select className="form-select" value={request.type}
                                    name="type"
                                        onChange={inputOnChangeHandler}>
                                        <option value={''}>--Select backend type--</option>
                                        {Array.from(backendTypes).map((item, index) => (
                                            <option value={item} key={index}>{item}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="rootDirectory" className="form-label">Root directory</label>
                                    <input
                                        name="root_dir"
                                        className={"form-control"}
                                        disabled={request.type !== 'Sharepoint' ? 'disabled' : ''}
                                        id="rootDirectory"
                                        value={request.root_dir}
                                        onChange={inputOnChangeHandler} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="authKey" className="form-label">Auth key<span className="mandatory-fields">*</span></label>
                                    <input type="text" className="form-control" id="authKey"
                                        value={request.auth_key}
                                        name='auth_key'
                                        onChange={inputOnChangeHandler} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="authSecret" className="form-label">Auth secret<span className="mandatory-fields">*</span></label>
                                    <input type="text" className="form-control" id="authSecret"
                                        value={request.auth_secret}
                                        name='auth_secret'
                                        onChange={inputOnChangeHandler} />
                                </div>
                                <div className="col-md-12 mb-3">
                                    <label htmlFor="authUrl" className="form-label">Auth URL</label>
                                    <input type="text" className="form-control" id="authSecret"
                                        value={request.auth_url}
                                        name='auth_url'
                                        onChange={inputOnChangeHandler} />
                                </div>
                            </div>

                            {
                                testConnectionStatus === 'ok' && (
                                    <div className="alert alert-success" role="alert">
                                        Test connection successful.!
                                    </div>
                                )
                            }
                            {
                                testConnectionStatus === 'error' && (
                                    <div className="alert alert-danger" role="alert">
                                        {testConnectionMessage}
                                    </div>
                                )
                            }
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <button type="button" className="btn btn-dark" onClick={() => testConnection()}>Test connection</button>

                            <div>
                                <button type="reset" className="btn btn-secondary me-2" data-bs-dismiss="modal" onClick={handleCloseEdit}>Close</button>
                                {
                                    testConnectionStatus === 'ok' && <button type="submit" className="btn btn-primary" >{editBackend.edit ? 'Save Storage' : 'Add Storage'}</button>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div className='alert-container'>
        <AlertMessageBox
                    showAlertBox={showAlertBox}
                    setShowAlertBox={setShowAlertBox}
                    alertMessage={alertMessage}
                />
       </div>
        
        </>
    )
}